import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileDocx.tsx
const IconFileDocx = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h13v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#6b91f2",
			fillRule: "evenodd",
			d: "M6 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm.13 1.902h1.578q.414 0 .756.132t.582.396q.24.258.372.654.132.39.132.912t-.132.918a1.8 1.8 0 0 1-.372.654 1.54 1.54 0 0 1-.582.39q-.342.132-.756.132H6.13zm2.22 3.15q-.234.228-.642.228h-.666v-2.568h.666q.408 0 .642.228t.234.732v.648q0 .504-.234.732m2.888.972q.342.138.756.138t.756-.138.582-.408q.24-.276.372-.678.132-.408.132-.942t-.132-.936a1.9 1.9 0 0 0-.372-.678 1.5 1.5 0 0 0-.582-.414 2 2 0 0 0-.756-.138q-.414 0-.756.138t-.582.414q-.24.27-.372.678-.132.402-.132.936t.132.942q.132.402.372.678.24.27.582.408m.756-.672q.414 0 .642-.27.234-.27.234-.774v-.624q0-.504-.234-.774-.228-.27-.642-.27t-.648.27q-.228.27-.228.774v.624q0 .504.228.774.234.27.648.27m4.295.81q-.426 0-.768-.132a1.6 1.6 0 0 1-.582-.402 1.9 1.9 0 0 1-.372-.666 3 3 0 0 1-.132-.936q0-.528.132-.936a1.9 1.9 0 0 1 .372-.69q.24-.282.582-.426t.768-.144q.582 0 .96.24.378.234.606.744l-.786.408a.9.9 0 0 0-.264-.42q-.174-.162-.516-.162a.84.84 0 0 0-.648.264q-.24.258-.24.756v.672q0 .498.24.762.246.258.648.258.336 0 .534-.18.204-.186.3-.444l.744.432q-.234.48-.618.744-.378.258-.96.258m4.523-.072h1.056l-1.362-2.148 1.29-2.04h-.984l-.828 1.416h-.018l-.816-1.416h-1.062l1.278 2.022-1.344 2.166h.984l.882-1.542h.018z",
			clipRule: "evenodd"
		})
	]
});
var IconFileDocx_default = forwardRef(IconFileDocx);
//#endregion
export { IconFileDocx_default as default };
